var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerIcon = function SvgHamburgerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 4.339H4.333v3.25h17.334v-3.25ZM21.667 18.422H4.333v3.25h17.334v-3.25ZM21.667 11.38H4.333v3.25h17.334v-3.25Z",
    fill: "#000"
  })));
};
export { SvgHamburgerIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjY2NjcgNC4zMzg3NUg0LjMzMzM0VjcuNTg4NzVIMjEuNjY2N1Y0LjMzODc1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxLjY2NjcgMTguNDIyMUg0LjMzMzM0VjIxLjY3MjFIMjEuNjY2N1YxOC40MjIxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxLjY2NjcgMTEuMzgwNEg0LjMzMzM0VjE0LjYzMDRIMjEuNjY2N1YxMS4zODA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";